"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueSettings = exports.QueueItem = exports.TopicConfig = exports.QueueProviderType = exports.AzureQueueConfig = exports.PgQueueConfig = void 0;
const typescript_json_serializer_1 = require("typescript-json-serializer");
const base_1 = require("../common/base");
const pgsql_1 = require("./pgsql");
/**
 * PgQueueConfig
 * Represents configuration settings specifically for PostgreSQL-based queues.
 * Extends the base PostgreSQL configuration to include future queue-specific settings.
 * @example
 * {
 *   "user": "postgres",
 *   "host": "db.example.com",
 *   "database": "queue_db",
 *   "password": "secure_pass",
 *   "port": 5432
 * }
 */
let PgQueueConfig = class PgQueueConfig extends pgsql_1.PgConfig {
    constructor(user, host, database, password, port) {
        super(user, host, database, password, port);
    }
};
PgQueueConfig = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String, String, String, Number])
], PgQueueConfig);
exports.PgQueueConfig = PgQueueConfig;
/**
 * Azure Queue Storage Configuration
 * Contains authentication details for connecting to Azure Queue Storage.
 *
 * @property azureApiQueueSasUrl - SAS URL for accessing the Azure queue
 * @property azureApiQueueSasToken - SAS token for authenticating requests
 */
let AzureQueueConfig = class AzureQueueConfig {
    constructor(azureApiQueueSasUrl, azureApiQueueSasToken) {
        this.azureApiQueueSasUrl = azureApiQueueSasUrl;
        this.azureApiQueueSasToken = azureApiQueueSasToken;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], AzureQueueConfig.prototype, "azureApiQueueSasUrl", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], AzureQueueConfig.prototype, "azureApiQueueSasToken", void 0);
AzureQueueConfig = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String])
], AzureQueueConfig);
exports.AzureQueueConfig = AzureQueueConfig;
/**
 * Queue Provider Type Specification
 *
 * Identifies the type of queue provider (e.g., "pg" for PostgreSQL or "azure" for Azure Queue Storage).
 * Used to determine which configuration to load for a queue if topic not present.
 *
 * @property queueProviderType - The type identifier of the queue provider
 *
 */
let QueueProviderType = class QueueProviderType {
    constructor(queueProviderType) {
        this.queueProviderType = queueProviderType;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueueProviderType.prototype, "queueProviderType", void 0);
QueueProviderType = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String])
], QueueProviderType);
exports.QueueProviderType = QueueProviderType;
/**
 * Topic-Specific Configuration
 *
 * Defines partitioning and queue preference settings for a specific topic.
 *
 * @property partitionCount - Number of partitions to create for this topic
 * @property preferredQueues - Ordered list of queue IDs that should be used for this topic
 *
 * @example
 * {
 *   "partitionCount": 4,
 *   "preferredQueues": ["pg_1", "azure_1"]
 * }
 */
let TopicConfig = class TopicConfig {
    constructor(partitionCount, preferredQueues) {
        this.partitionCount = partitionCount;
        this.preferredQueues = preferredQueues;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], TopicConfig.prototype, "partitionCount", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Array)
], TopicConfig.prototype, "preferredQueues", void 0);
TopicConfig = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [Number, Array])
], TopicConfig);
exports.TopicConfig = TopicConfig;
/**
 * Queue Definition Item
 *
 * Represents a single queue configuration with its connection details.
 *
 * @property id - Unique identifier for the queue
 * @property name - Human-readable name for the queue
 * @property type - Provider type ("pg" or "azure")
 * @property config - Provider-specific configuration object
 *
 * @example
 * {
 *   "id": "pg_1",
 *   "name": "Primary PostgreSQL Queue",
 *   "type": "pg",
 *   "config": {
 *     "user": "admin",
 *     "host": "db.example.com",
 *     "database": "main_db",
 *     "password": "secure_password",
 *     "port": 5432
 *   }
 * }
 */
let QueueItem = class QueueItem {
    constructor(id, name, type, config) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.config = config;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueueItem.prototype, "id", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueueItem.prototype, "name", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", String)
], QueueItem.prototype, "type", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ type: Object }),
    __metadata("design:type", Object)
], QueueItem.prototype, "config", void 0);
QueueItem = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String, String, Object])
], QueueItem);
exports.QueueItem = QueueItem;
/**
 * Queue System Configuration
 *
 * Root configuration object containing all queue settings for the application.
 *
 * @property defaultPartitionCount - Default number of partitions to use when not specified in topicsConfig
 * @property queues - List of available queue configurations
 * @property topicsConfig - Mapping of topic names to their specific configurations
 *
 * @example
 * Full example structure:
 * {
 *   "queueSettings": {
 *     "defaultPartitionCount": 0,
 *     "queues": [
 *       {
 *         "id": "pg_1",
 *         "name": "primary pg",
 *         "type": "pg",
 *         "config": {
 *           "user": "a123",
 *           "host": "127.0.0.1",
 *           "port": "5432",
 *           "password": "12345",
 *           "database": "postgres"
 *         }
 *       },
 *       {
 *         "id": "azure_1",
 *         "name": "primary azure",
 *         "type": "azure",
 *         "config": {
 *           "azureApiQueueSasUrl": "https://...",
 *           "azureApiQueueSasToken": "sastoken"
 *         }
 *       }
 *     ],
 *     "topicsConfig": {
 *       "appice-transactional-campaign-data": {
 *         "partitionCount": 0,
 *         "preferredQueues": ["azure_1", "pg_1"]
 *       },
 *       "appice-data": {
 *         "partitionCount": 44,
 *         "preferredQueues": ["azure_2"]
 *       }
 *     }
 *   }
 * }
 */
let QueueSettings = class QueueSettings extends base_1.BaseModel {
    constructor(defaultPartitionCount, queues, topicsConfig, partitionCount, pgQueueConfig) {
        super();
        this.defaultPartitionCount = defaultPartitionCount;
        this.queues = queues;
        this.topicsConfig = topicsConfig;
        this.partitionCount = partitionCount;
        this.pgQueueConfig = pgQueueConfig;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], QueueSettings.prototype, "defaultPartitionCount", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ type: QueueItem }),
    __metadata("design:type", Array)
], QueueSettings.prototype, "queues", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ isDictionary: true, type: TopicConfig }),
    __metadata("design:type", Object)
], QueueSettings.prototype, "topicsConfig", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", PgQueueConfig
    //TODO remove in future
    )
], QueueSettings.prototype, "pgQueueConfig", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)(),
    __metadata("design:type", Number)
], QueueSettings.prototype, "partitionCount", void 0);
QueueSettings = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [Number, Array, Object, Number, PgQueueConfig])
], QueueSettings);
exports.QueueSettings = QueueSettings;
